<template>
  <div class="home-page container-md">
    <h4 class="font-weight-bold text-center mb-4">本课程实现的组件</h4>
    <div class="row">
      <div v-for="component in componentsData" :key="component.name" class="col-4 mb-4">
        <div class="card h-100 shadow-sm">
          <div class="card-body text-center">
            <div class="img-holder d-flex justify-content-center">
              <img :src="require(`../assets/${component.path}`)" :alt="component.name" class="border border-light my-3" >
            </div>
            <h5 class="card-title text-truncate">{{component.enName}} {{component.name}}</h5>
            <!-- <p class="card-text text-left description text-secondary">{{column.description}}</p> -->
            <router-link :to="`/${component.enName.toLowerCase()}`" class="btn btn-outline-primary">查看 Demo</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
const componentsData = [
  { name: '下拉菜单', enName: 'Dropdown', path: 'Dropdown.svg' },
  { name: '验证表单', enName: 'Form', path: 'Form.svg' },
  { name: '全局读取', enName: 'Loading', path: 'Spin.svg' },
  { name: '全局提示', enName: 'Alert', path: 'Alert.svg' },
  { name: '对话框', enName: 'Modal', path: 'Modal.svg' },
  { name: '上传', enName: 'Upload', path: 'Upload.svg' }
]
export default defineComponent({
  setup () {
    return {
      componentsData
    }
  }
})
</script>

<style scoped>
.card-body img {
  width: 120px;
}
.img-holder {
  height: 150px;
}
.description {
  line-height: 20px;
  height: 60px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-all;
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
